import image1 from '@/main/assets/images/homepage/asset@3x.png';
import image2 from '@/main/assets/images/homepage/xnuup_03_Van_large.jpg';

import * as S from './styles';
import TextImage from '../components/textImage/textImage';
import { getTranslateByKey } from '@/main/services/utils';

function HomepageCookies() {
  return (
    <S.Container>
      <S.FirstSection $backgroundImage={image1}>
        <TextImage
          backgroundImage={image2}
          title={getTranslateByKey('information.cookies')}
          description=""
          positionImage="right"
          idImage="id-homepage-cookies-image-2"
          imageProps={{
            clipBorderImage: 'bottom',
            width: '540px',
            height: '609px'
          }}
        />
      </S.FirstSection>
      <S.TextContainer>
        {getTranslateByKey('information.homepageCookies1')}
        <br />
        <br />
        {getTranslateByKey('information.homepageCookies2')}
        <br />
        <br />
        {getTranslateByKey('information.homepageCookies3')}
        <br />
      </S.TextContainer>
    </S.Container>
  );
}

export default HomepageCookies;
